import { List, Skeleton, Stack } from "@mui/material";


export function USkeletons(props) {
    const { count, ...rest } = props;
    const ret = []
    for (let i = 0; i < count; i++) {
        ret.push(<Skeleton variant="rectangular" {...rest} key={"s" + i} />)
    }
    return ret;
}
export function USkeletonList(props) {
    const { margin, ...rest } = props;
    return <List>
        <USkeletons sx={{
            marginBottom: margin || 2,
            ...rest.sx,
        }} {...rest} />
    </List>
}
